'use strict';

var bi = require('../bi');
var events = require('../events');
var errors = require('../errors');

function importScriptsAsNpmModule(workerGlobalScope, url, appId, scriptName) {
  var module = workerGlobalScope.module = {};
  workerGlobalScope.module.exports = {};
  workerGlobalScope.exports = workerGlobalScope.module.exports;
  var beforeLoad = Date.now();
  try {
    workerGlobalScope.importScripts(url);
    reportBI(events.SCRIPT_LOAD, {
      app_id: appId,
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad
    });
  } catch (err) {
    reportBI(errors.SCRIPT_LOAD, {
      app_id: appId,
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad,
      error: err.message
    });
    /*eslint-disable no-console*/
    console.error('Failed to import script: ' + scriptName + ', url: ' + url);
  }
  delete workerGlobalScope.module;
  delete workerGlobalScope.exports;
  return module.exports;
}

function importScriptsAsAmdModule(workerGlobalScope, url, appId, scriptName) {
  var definedModule = null;
  var oldDefine = workerGlobalScope.define;
  workerGlobalScope.define = function define(deps, mod) {
    definedModule = mod;
  };
  workerGlobalScope.define.amd = true;
  var beforeLoad = Date.now();
  try {
    workerGlobalScope.importScripts(url);
    reportBI(events.SCRIPT_LOAD, {
      app_id: appId,
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad
    });
  } catch (err) {
    var errorMsg = err && err.message;
    reportBI(errors.SCRIPT_LOAD, {
      app_id: appId,
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad,
      error: errorMsg
    });
    /*eslint-disable no-console*/
    console.error('Failed to import script: ' + scriptName + ', url: ' + url);
    return function() { return {}; };
  }

  if (oldDefine) {
    workerGlobalScope.define = oldDefine;
  } else {
    delete workerGlobalScope.define;
  }

  return definedModule;
}

function sendMessage(message, ports) {
  const args = [message.data || message];

  if (typeof WorkerGlobalScope === 'undefined') {
    args.push('*');
  }
  if (ports) {
    args.push(ports);
  }

  return self.postMessage.apply(self, args);
}

function reportBI(reportDef, params) {
  bi.report(sendMessage, reportDef, params);
}

module.exports = {
  importScriptsAsNpmModule: importScriptsAsNpmModule,
  importScriptsAsAmdModule: importScriptsAsAmdModule,
  reportBI: reportBI,
  sendMessage
};



// WEBPACK FOOTER //
// ./src/main/worker/workerUtils.js